import React from 'react';
import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react';
import { CustomButton } from 'components/buttons';
import { Icon } from '@mdi/react';
import './LogoutConfirmModal.scss';

interface LogoutConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  userName?: string;
}

export const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  userName
}) => {
  const exitIcon = require('materialdesign-js/icons/mdiExitToApp').default;
  const alertIcon = require('materialdesign-js/icons/mdiAlertCircleOutline').default;

  return (
    <CModal
      alignment="center"
      visible={isOpen}
      backdrop="static"
      onClose={onCancel}

      className="logout-modal"
    >
      <CModalHeader className="logout-header">
        <div className="d-flex align-items-center">
          <Icon 
            path={alertIcon} 
            size={1} 
            className="text-warning me-2"
          />
          <CModalTitle>
            Confirmar Cierre de Sesión
          </CModalTitle>
        </div>
      </CModalHeader>
      
      <CModalBody className="text-center py-4">
        <p className="mb-3">
          {userName ? (
            <>¿Estás seguro de que deseas cerrar tu sesión, <strong>{userName}</strong>?</>
          ) : (
            '¿Estás seguro de que deseas cerrar tu sesión?'
          )}
        </p>
        <small className="text-muted">
          Tendrás que volver a iniciar sesión para acceder a la plataforma.
        </small>
      </CModalBody>
      
      <CModalFooter className="d-flex justify-content-center gap-3">
        <CustomButton
          variant="outline"
          color="secondary"
          onClick={onCancel}
        >
          Cancelar
        </CustomButton>
        <CustomButton
          color="danger"
          onClick={onConfirm}
          icon={<Icon path={exitIcon} size={0.8} />}
        >
          Cerrar Sesión
        </CustomButton>
      </CModalFooter>
    </CModal>
  );
};